<template>
  <div class="ebPanel" @mouseenter="mouseenter($event)" @mouseleave="mouseleave($event)">
    <div class="panel-red-line"></div>
    <div class="panel-main">
      <slot name="header"></slot>
      <div class="panel-body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'ebPanel',
  methods: {
    mouseenter: function(event) {
      var height = $(event.target).height() - 2;
      $(event.target)
        .find('.panel-red-line')
        .css('height', height);
    },
    mouseleave: function() {
      $(event.target)
        .find('.panel-red-line')
        .css('height', 15);
    }
  }
};
</script>
<style scoped lang="less">
.ebPanel {
  height: 100%;
  width: 100%;
  padding: 20px 0;
  display: flex;
  flex-wrap: wrap;
  &:hover {
    box-shadow: 2px 2px 10px #ccc;
  }
  .panel-red-line {
    height: 15px;
    width: 5px;
    background: #fb5b3b;
    margin: 2px 19px 0 14px;
    transition: height 0.5s linear;
  }
  .panel-main {
    width: 95%;
    .panel-header {
    }
    .panel-body {
      height: 100%;
      transition: height 0.5s linear;
      overflow: hidden;
    }
  }
}
.panelHide {
  .panel-red-line {
    height: 15px !important;
  }
  .panel-body {
    height: 0 !important;
  }
}
</style>
